<template>
  <div class="container">
    <app-bar
      :title="popup?.judul ?? '...'"
      previousLink="/"
    />
    <div v-if="popup?.image" class="row">
      <img :src="popup.image" alt="popup" class="img-fluid">
    </div>
  </div>
</template>

<script>
import { getPopup, popup, loading } from '../../core/popup'
import { nextTick, onMounted } from 'vue'
import AppBar from '../../components/AppBar.vue'
import { title } from '@/core/page'
import { useRouter } from 'vue-router'

export default {
  name: 'Popup',
  components: {
    AppBar
  },
  setup () {
    const router = useRouter()

    onMounted(async () => {
      try {
        await getPopup()
        if (!popup.value) {
          router.push('/')
        }
      } catch (error) {
        console.error('Error dari page Popup getPopup', error)
        router.push('/')
        throw error
      }

      nextTick(() => {
        title.value = popup.value?.judul ?? '...'
      })
    })

    return {
      popup,
      loading
    }
  }
}
</script>
